export const sampleInvestor = (override) => (Object.assign({ sub: 'my-id', investorId: 'my-investor-id', firstName: 'Jeremy', lastName: 'Spring', email: 'jitewaboh@lagify.com', signedInWithSSO: false, changeEmail: {
        emailVerified: true,
    } }, override));
